export const BaseUrl = "https://api.awlindia.com/";
